import FoldersAccordion from './FoldersAccordion';

export default FoldersAccordion;
